// LocalStorage wrappers for history and favourites
const HIST_KEY = "rng_history_v1";
const FAV_KEY = "rng_favorites_v1";
const MAX_HISTORY = 50;

function safeRead(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch (err) {
    console.error(`storage.safeRead(${key}) failed`, err);
    return fallback;
  }
}

function safeWrite(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error(`storage.safeWrite(${key}) failed`, err);
  }
}

export function getHistory() {
  return safeRead(HIST_KEY, []);
}

export function addHistory(entry) {
  const list = getHistory();
  const item = {
    id: Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
    ts: new Date().toISOString(),
    ...entry,
  };
  const next = [item, ...list].slice(0, MAX_HISTORY);
  safeWrite(HIST_KEY, next);
  return item;
}

export function clearHistory() {
  safeWrite(HIST_KEY, []);
}

export function removeHistory(id) {
  const next = getHistory().filter((h) => h.id !== id);
  safeWrite(HIST_KEY, next);
}

export function getFavorites() {
  return safeRead(FAV_KEY, []);
}

export function isFavorite(slug) {
  return getFavorites().includes(slug);
}

export function toggleFavorite(slug) {
  const favs = getFavorites();
  const next = favs.includes(slug) ? favs.filter((s) => s !== slug) : [...favs, slug];
  safeWrite(FAV_KEY, next);
  return next;
}
